/* prettier-ignore */
/**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */
//Japanese
export default {
  'embedded-confluence-common.src.content.empty-state-description': 'お探しのページが存在しません。削除された可能性があります。URL に入力ミスがないか、ご確認ください 😉',
  'embedded-confluence-common.src.content.empty-state-header': 'お探しのものが見つかりませんでした',
  'embedded.confluence.already-logged-in-paragraph': 'ログインしていますか?更新してみてください。',
  'embedded.confluence.footer.hover.text': 'Confluence で表示',
  'embedded.confluence.footer.prefix': '使用ソリューション: ',
  'embedded.confluence.generic-error-page.login-to-confluence-button': 'Confluence にログイン',
  'embedded.confluence.login-page.login-button': 'Confluence にログイン',
  'embedded.confluence.login-page.login-button.aria-label': 'ログイン ボタン',
  'embedded.confluence.login-page.login-text': 'このページを表示するには、ログインする必要があります',
  'embedded.confluence.login-page.refresh-page-banner': 'ログインすると、このページは自動で更新されます。更新されない場合は、ここをクリックして更新できます',
  'embedded.confluence.login-page.refresh-page-banner-refresh-link': 'ページを更新',
  'embedded.confluence.need-to-log-in-paragraph': 'このページを表示するには、ログインする必要があります。',
  'embedded.confluence.still-having-trouble-paragraph': '問題が解決しない場合は、サードパーティ Cookie が有効になっていることを確認してください。または、{link}',
  'embedded.confluence.troubleshooting-link-text': 'このトラブルシューティング ガイドを参照してください。',
  'embedded.confluence.troubleshooting-link.aria-label': 'トラブルシューティング ガイドのリンク'
};